module.exports = __webpack_public_path__ + "media/images/version_merge/cmnd_front_example-da9585f8186535f4b08fec3e095f2b31.jpg";